// A'gong Footer — scroll-triggered entrance animations
document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('[data-agong-footer]')) return;

  if (!window.IntersectionObserver) {
    document.querySelectorAll('.agong-footer__group').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.agong-footer__group').forEach(function (el) {
    observer.observe(el);
  });
});
